export default __webpack_public_path__ + "static/media/GillSansBold.6110e26a.otf";